import React from 'react';

export const MF_DISCLAIMER = 'Mutual Fund investments are subject to market risks, read all scheme related documents carefully.';

export const COMMISSION_DISCLOSURE =
  'Impetus Investment Services is an AMFI-registered Mutual Fund Distributor. We may receive commissions from Asset Management Companies for investments made through Regular Plans of mutual fund schemes. Relevant commission disclosures will be provided in accordance with applicable regulations.';

export const NON_MF_NOTE =
  'Fixed deposits, insurance, bonds, real estate and Alternative Investment Funds are not mutual fund products and are not covered by our AMFI registration (ARN: 116347). Where offered, they are arranged through the respective issuer, insurer, provider or appropriately registered partner, subject to their terms and applicable regulations.';

export const NonMFNote = ({ testId = 'non-mf-note', className = '' }) => (
  <p className={`text-xs font-body text-[#737373] leading-relaxed ${className}`} data-testid={testId}>
    <strong className="text-[#A0451E]">Please note:</strong> {NON_MF_NOTE}
  </p>
);
